"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const native_base_1 = require("native-base");
const icons_1 = require("@native-base/icons");
//import MapView, {PROVIDER_GOOGLE, Circle} from 'react-native-maps';
const ClaimGraph_1 = __importDefault(require("./ClaimGraph"));
const SapporoLikePanel_1 = __importDefault(require("./SapporoLikePanel"));
const UI_1 = require("./UI");
const saveClaim_1 = require("./storage/saveClaim");
const Firebase_1 = require("./Firebase");
// import analytics from '@react-native-firebase/analytics';
// import {UserContext} from './App';
// import {saveLikeStatus} from './storage/saveClaim';
const getLastClaim_1 = require("./storage/getLastClaim");
const SapporoClaimView = ({ getImage, getUIComponents, passedUser, claim, victory, active, refreshClaim, getLocationView, }) => {
    // if we have no claim, don't proceed
    if (!claim) {
        return null;
    }
    (0, react_1.useEffect)(() => {
        const unsub = (0, getLastClaim_1.subscribeToClaim)(firebase, claim.id, snapshot => {
            onRefresh();
        });
        return unsub;
    }, []);
    const firebase = (0, react_1.useContext)(Firebase_1.FirebaseContext);
    const [savingLike, setSavingLike] = (0, react_1.useState)(false);
    //   const contextUser = useContext(UserContext);
    //   const user = passedUser || contextUser;
    const user = passedUser;
    const { header, description, location } = claim;
    //  const provider = Platform.OS === 'ios' ? undefined : PROVIDER_GOOGLE;
    const [refreshing, setRefreshing] = (0, react_1.useState)(false);
    const [userScored, setUserScored] = (0, react_1.useState)(claim && claim.userReaction ? claim.userReaction.like : false);
    const [userScoreValue, setUserScoreValue] = (0, react_1.useState)(claim && claim.userReaction ? claim.userReaction.score : 50);
    const [isShowingHelp, setIsShowingHelp] = (0, react_1.useState)(false);
    const claimID = claim === null || claim === void 0 ? void 0 : claim.id;
    const setLikeClaim = (like) => {
        setUserScored(like);
        likeClaim(like, userScoreValue);
    };
    const setScoreValue = (value) => {
        setUserScoreValue(value);
    };
    const likeClaim = (like, value) => __awaiter(void 0, void 0, void 0, function* () {
        if (user && claim && user.uid) {
            if (claimID) {
                setSavingLike(true);
                yield (0, saveClaim_1.saveLikeStatus)(firebase, claimID, user.uid, like, value);
                setSavingLike(false);
            }
        }
        else {
            console.log('No user claim or uid?', user, claim);
        }
    });
    const saveScore = (value) => __awaiter(void 0, void 0, void 0, function* () {
        console.log('Value ', value);
        if (value) {
            console.log('Saving Score:', value);
            setScoreValue(value);
        }
        else {
            console.log('Saving Score: no value', userScoreValue);
            setScoreValue(userScoreValue);
        }
        yield likeClaim(true, value);
    });
    const onRefresh = (0, react_1.useCallback)(() => {
        setRefreshing(true);
        refreshClaim().then(() => {
            setRefreshing(false);
        });
    }, []);
    //   useEffect(() => {
    //     if (claimID && active) {
    //       return subscribeToClaim(claimID, onRefresh);
    //     }
    //   }, [active, claimID]);
    (0, react_1.useEffect)(() => {
        //console.log('VIEW IS ACTIVE?', active);
    }, [active]);
    //   useEffect(() => {
    //     analytics().logScreenView({
    //       screen_class: 'view',
    //       screen_name: 'claim',
    //     });
    //   });
    //   const styles = StyleSheet.create({
    //     container: {
    //       ...StyleSheet.absoluteFillObject,
    //       height: 200,
    //       width: 400,
    //       justifyContent: 'flex-end',
    //       alignItems: 'center',
    //     },
    //     map: {
    //       ...StyleSheet.absoluteFillObject,
    //     },
    //   });
    const getHelpSignificance = () => {
        return (react_1.default.createElement(native_base_1.Popover, { placement: "top", isOpen: isShowingHelp, onClose: () => {
                setIsShowingHelp(false);
            }, trigger: triggerProps => {
                return (react_1.default.createElement(native_base_1.IconButton, Object.assign({}, triggerProps, { m: 0, p: 0, icon: react_1.default.createElement(native_base_1.VStack, { m: 0, p: 0 },
                        react_1.default.createElement(native_base_1.Icon, { as: react_1.default.createElement(icons_1.AntDesign, { name: "infocirlce" }), size: 3, ml: "1", color: UI_1.backgroundPrimary }),
                        react_1.default.createElement(native_base_1.Spacer, { h: 3 })), onPress: () => {
                        setIsShowingHelp(!isShowingHelp);
                    } })));
            } },
            react_1.default.createElement(native_base_1.Popover.Content, { borderWidth: 1, borderColor: UI_1.backgroundSecondary, w: "456" },
                react_1.default.createElement(native_base_1.Popover.Arrow, { bg: UI_1.backgroundSecondary }),
                react_1.default.createElement(native_base_1.Popover.CloseButton, null),
                react_1.default.createElement(native_base_1.Popover.Header, { _text: {
                        fontFamily: 'Montserrat',
                    } }, "Significance Score"),
                react_1.default.createElement(native_base_1.Popover.Body, null, "Not all claims have the same impact or significance. When a new guard stakes a claim for The Sapporo, there are three key characteristics they must consider: Idiocy, Style, and Reach. Like all things Sapporo, these values are self-assigned and are defined below. And remember, this is for posterity so be honest."),
                react_1.default.createElement(native_base_1.Popover.Body, null,
                    react_1.default.createElement(native_base_1.Heading, { size: "sm", fontFamily: 'Montserrat', fontWeight: "500" }, "Idiocy"),
                    "On a scale of 1-100, just how dumb do you feel once you realize what you've done? Just because it could happen to anyone doesn't make it any less stupid."),
                react_1.default.createElement(native_base_1.Popover.Body, null,
                    react_1.default.createElement(native_base_1.Heading, { size: "sm", fontFamily: 'Montserrat', fontWeight: "500" }, "Style (Spirit)"),
                    "Despite this being a 1-100 scale, the \"Style\" or \"Spirit\" of the Sapporo can be the most subjective. How \"Sapporo\" was this incident? How forrest for the trees was it? How could a smart person be so dumb was it? How obvious was the error that led to the sidetrack? How befuddled and irritated did you get when whatever it was wasn't working?"),
                react_1.default.createElement(native_base_1.Popover.Body, null,
                    react_1.default.createElement(native_base_1.Heading, { size: "sm", fontFamily: 'Montserrat', fontWeight: "500" }, "Reach"),
                    "Just how big was this Sapporo? How long did it last? Did you get others involved and did they also not immediately see what was going on and go down the rabbit hole with you? On a scale of 1-100, just how far did this thing go?"))));
    };
    return (react_1.default.createElement(native_base_1.ScrollView, { _contentContainerStyle: {
            px: '20px',
            mb: '4',
            minW: '72',
        }, bg: "#FFFFFF", p: 2, width: "95%", rounded: 'lg' },
        react_1.default.createElement(native_base_1.Box, { p: 3, rounded: "lg", bg: "#FFFFFF" },
            react_1.default.createElement(native_base_1.VStack, null,
                react_1.default.createElement(native_base_1.Heading, { fontFamily: 'Montserrat', color: UI_1.backgroundSecondary }, header),
                react_1.default.createElement(native_base_1.Stack, { space: "sm", p: 1 },
                    !!claim.user && (react_1.default.createElement(native_base_1.Text, { fontSize: "sm", _light: {
                            color: 'blue.600',
                        }, _dark: {
                            color: 'blue.400',
                        }, fontWeight: "500", fontFamily: 'Montserrat', ml: "-0.5", mt: "-1" },
                        "Owner: ",
                        claim.user.displayName)),
                    react_1.default.createElement(native_base_1.Text, { fontSize: "xs", fontFamily: 'Montserrat', _light: {
                            color: 'blue.600',
                        }, _dark: {
                            color: 'blue.400',
                        }, fontWeight: "500", ml: "-0.5", mt: "-3" },
                        "Claimed: ",
                        claim.toLocalTimeString(),
                        " \u2022",
                        ' ',
                        claim.toRelativeTimeString()),
                    react_1.default.createElement(SapporoLikePanel_1.default, { busy: savingLike, userReaction: claim === null || claim === void 0 ? void 0 : claim.userReaction, userScoreValue: userScoreValue, reactionCount: claim.reactionCount || 0, reactionScore: claim.reactionScore || 0, onScoreChange: (v) => {
                            console.log('Changing');
                            setScoreValue(Math.floor(v));
                        }, saveScore: (v) => {
                            saveScore(v);
                        }, onPress: () => {
                            if (!savingLike) {
                                console.log('Scoring toggle', !userScored);
                                setLikeClaim(!userScored);
                            }
                        }, userScored: userScored }),
                    react_1.default.createElement(native_base_1.Divider, { pt: 0 }),
                    react_1.default.createElement(native_base_1.Text, { fontWeight: "400", fontFamily: 'Montserrat' }, description)),
                react_1.default.createElement(native_base_1.Divider, null),
                react_1.default.createElement(native_base_1.VStack, null,
                    react_1.default.createElement(native_base_1.Center, { mt: 5 },
                        react_1.default.createElement(native_base_1.HStack, { m: 0, p: 0 },
                            react_1.default.createElement(native_base_1.Heading, { size: "md", fontFamily: 'Montserrat', fontWeight: "500" }, "Significance"),
                            getHelpSignificance()),
                        react_1.default.createElement(ClaimGraph_1.default, { victory: victory, getUIComponents: getUIComponents, getImage: getImage, claim: claim }),
                        react_1.default.createElement(native_base_1.Text, { fontSize: "xs", _light: {
                                color: 'violet.500',
                            }, _dark: {
                                color: 'violet.400',
                            }, fontWeight: "500", fontFamily: 'Montserrat', ml: "-0.5", mt: "-1" },
                            "Idiocy: ",
                            claim.idiocy,
                            " \u2022 Style: ",
                            claim.spirit,
                            " \u2022 Reach:",
                            ' ',
                            claim.reach))),
                react_1.default.createElement(native_base_1.Divider, null),
                react_1.default.createElement(native_base_1.VStack, null,
                    react_1.default.createElement(native_base_1.Center, null,
                        react_1.default.createElement(native_base_1.Heading, { p: 3, size: "md", fontFamily: 'Montserrat', fontWeight: "500" }, "Location"),
                        getLocationView(location)))))));
};
exports.default = SapporoClaimView;
/**
 *       refreshControl={
        <RefreshControl
          refreshing={refreshing}
          onRefresh={onRefresh}
          progressBackgroundColor={backgroundPrimary}
          colors={[backgroundSecondary]}
        />
      }

            bg={{
        linearGradient: {
          colors: [backgroundPrimary, backgroundSecondary],
          start: [0.4, 0],
          end: [0.9, 0],
        },
      }}

 */
